import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { UnifiedDemoPage } from './pages/UnifiedDemoPage';
import { BirdsnestHeaderSearch } from './pages/BirdsnestHeaderSearch';
// Set to true to use Birdsnest design
const USE_BIRDSNEST_DESIGN = 1;
const mountElement = document.getElementById('header-search-dropdown');
if (mountElement) {
    const PageComponent = USE_BIRDSNEST_DESIGN ? BirdsnestHeaderSearch : UnifiedDemoPage;
    if (mountElement.hasChildNodes()) {
        hydrate(h(PageComponent, null), mountElement);
    }
    else {
        render(h(PageComponent, null), mountElement);
    }
}
